import React, { useState } from 'react'; // 1. Added useState
import iic from '../Assets/IIC.png';

const IIICell = () => {
  const [isModalOpen, setIsModalOpen] = useState(false); // 2. State for modal

const members = [
  { id: 1, name: "JANNU SIVA KUMAR", designation: "PRINCIPAL", role: "Chairman" },
  { id: 2, name: "G.LAKSHMI PRATAP", designation: "TPO & HOD/ECE", role: "Convenor" },

  { id: 3, name: "R SAI TEJA", designation: "HOD/CIV", role: "MEMBER" },
  { id: 4, name: "V NAGESWARA RAO", designation: "HOD/EEE", role: "MEMBER" },
  { id: 5, name: "P SIDDI RAJU", designation: "HOD/MEC", role: "MEMBER" },
  { id: 6, name: "P B N V SUBRAHMANYAM", designation: "HOD/CME", role: "MEMBER" },
  { id: 7, name: "KIRAN KUMAR DONEPUDI", designation: "DIRECTOR – CHANNEL SOFT IT SERVICES PRIVATE LIMITED", role: "MEMBER" },
  { id: 8, name: "B. PRASAD RAJU", designation: "MANAGING PARTNER -RATNA INFRASTRUCTURES", role: "MEMBER" },
  { id: 9, name: "A PRATIMA", designation: "MANAGER-GROWEL PROCESSORS Pvt. Ltd", role: "MEMBER" },
  { id: 10, name: "R MADHAVI", designation: "MANAGER EFFTRONICS SYSTEMS Pvt. Ltd.", role: "MEMBER" },
  { id: 11, name: "V MURALI", designation: "PROPRIETOR - MAHA LIFTS", role: "MEMBER" },
];

  return (
    <div className="bg-slate-50 min-h-screen py-10 px-4 sm:px-6 lg:px-8 font-sans">
      <div className="max-w-6xl mx-auto space-y-8">
        
        {/* Page Header */}
        <div className="bg-indigo-900 text-white p-10 rounded-2xl shadow-xl relative overflow-hidden">
          <div className="relative z-10">
            <h1 className="text-3xl md:text-4xl font-extrabold tracking-tight mb-2">
              INDUSTRY - INSTITUTE INTERACTION CELL (IIC)
            </h1>
            <div className="flex items-center space-x-2 text-indigo-200">
              <span className="bg-indigo-700 px-3 py-1 rounded text-sm font-mono border border-indigo-500">
                IIC ID: IC202323340
              </span>
              <span className="text-sm">| Ministry of Education’s Innovation Cell (MIC)</span>
            </div>
          </div>
          <div className="absolute -right-10 -top-10 w-64 h-64 bg-indigo-800 rounded-full opacity-50"></div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          
          {/* Left Column: Description */}
          <div className="lg:col-span-2 space-y-6">
            <section className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100">
              <h2 className="text-xl font-bold text-gray-900 mb-4 border-l-4 border-indigo-600 pl-4">
                Our Vision & Mission
              </h2>
              <p className="text-gray-700 leading-relaxed text-justify mb-4">
                To create an enabling ecosystem for <strong>Innovation and Entrepreneurship</strong> within our campus, our Sri Jyothi Polytechnic has established the Institution’s Innovation Council (IIC). The IIC aims to systematically nurture creativity, cultivate innovative thinking, and promote an entrepreneurial mindset among students and faculty.
              </p>
              <p className="text-gray-700 leading-relaxed text-justify">
                This initiative reflects our commitment to fostering a vibrant environment where students can explore opportunities, incubate their ideas, and transform them into viable technological or entrepreneurial ventures, strictly following the guidelines of the Ministry of Education’s Innovation Cell.
              </p>
            </section>

            {/* Activities Grid */}
            <section className="bg-indigo-50 p-8 rounded-2xl border border-indigo-100">
              <h3 className="font-bold text-indigo-900 mb-4">Key Activities & Focus Areas:</h3>
              <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
                {[
                  "Idea Generation", "Innovation Challenges", "Hackathons", 
                  "Expert Talks", "Mentorship Sessions", "Industry Visits"
                ].map((act, i) => (
                  <div key={i} className="bg-white p-3 rounded-lg shadow-sm border border-indigo-100 text-sm font-semibold text-indigo-700 flex items-center">
                    <span className="w-2 h-2 bg-indigo-500 rounded-full mr-2"></span>
                    {act}
                  </div>
                ))}
              </div>
            </section>

            {/* Committee Table */}
            <section className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
              <div className="bg-gray-50 px-6 py-4 border-b">
                <h3 className="font-bold text-gray-800 uppercase tracking-wider text-sm">Committee Members</h3>
              </div>
              <div className="overflow-x-auto">
                <table className="w-full text-left">
                  <thead className="bg-white text-gray-400 uppercase text-[10px] font-bold tracking-widest border-b">
                    <tr>
                      <th className="px-6 py-4">S.No</th>
                      <th className="px-6 py-4">Name of the Faculty</th>
                      <th className="px-6 py-4">Designation</th>
                      <th className="px-6 py-4 text-center">Appointed As</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-50">
                    {members.map((member) => (
                      <tr key={member.id} className="hover:bg-indigo-50/30 transition">
                        <td className="px-6 py-4 text-gray-400 font-medium">{member.id}</td>
                        <td className="px-6 py-4 font-bold text-gray-900">{member.name}</td>
                        <td className="px-6 py-4 text-gray-600 text-sm">{member.designation}</td>
                        <td className="px-6 py-4 text-center">
                          <span className={`px-3 py-1 rounded text-[10px] font-black tracking-tighter ${
                            member.role === 'CONVENER' 
                            ? 'bg-indigo-600 text-white' 
                            : 'bg-gray-100 text-gray-600 border border-gray-200'
                          }`}>
                            {member.role}
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </section>
          </div>

          {/* Right Column: Certificate Display */}
          <div className="lg:col-span-1">
            <div className="bg-white p-6 rounded-2xl shadow-lg border border-gray-100 sticky top-10">
              <div className="flex items-center mb-4 space-x-2">
                <svg className="w-5 h-5 text-amber-500" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                </svg>
                <h3 className="font-bold text-gray-900">Establishment Certificate</h3>
              </div>
              
              {/* Certificate Image Frame (Trigger) */}
              <div 
                className="relative group overflow-hidden rounded-lg border-4 border-gray-50 shadow-inner bg-gray-100 cursor-zoom-in"
                onClick={() => setIsModalOpen(true)} // 3. Click to open
              >
                <img 
                  src={iic}
                  alt="IIC Establishment Certificate" 
                  className="w-full h-auto object-contain transition-transform duration-500 group-hover:scale-105"
                  onError={(e) => {
                    e.target.src = "https://via.placeholder.com/400x560?text=IIC+Certificate+Image+Not+Found";
                  }}
                />
                <div className="absolute inset-0 bg-indigo-900/10 group-hover:bg-transparent transition-colors flex items-center justify-center opacity-0 group-hover:opacity-100">
                   <span className="bg-white/90 text-indigo-900 px-4 py-3 rounded-full text-sm font-bold shadow-lg">Click to View</span>
                </div>
              </div>
              
              <p className="mt-4 text-xs text-gray-500 text-center italic">
                Authorized by Ministry of Education Innovation Cell (MIC)
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* 4. Full Screen Modal Overlay */}
      {isModalOpen && (
        <div 
          className="fixed inset-0 z-[100] flex items-center justify-center bg-black/90 p-4 md:p-10 animate-in fade-in duration-300"
          onClick={() => setIsModalOpen(false)} // Close when clicking background
        >
          {/* Close Button */}
          <button 
            className="absolute top-6 right-6 text-white hover:text-indigo-400 transition-colors z-[110]"
            onClick={() => setIsModalOpen(false)}
          >
            <svg className="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>

          {/* Full Screen Image */}
          <img 
            src={iic} 
            alt="Full Screen Certificate" 
            className="max-w-full max-h-full object-contain rounded-sm shadow-2xl animate-in zoom-in-95 duration-300"
            onClick={(e) => e.stopPropagation()} // Prevent closing when clicking the image itself
          />
        </div>
      )}
    </div>
  );
};

export default IIICell;